import { useEffect, useState } from 'react'
import { auth } from 'firebase/index'
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from 'reducks/loading/operations'
import axios, { AxiosResponse } from 'axios'
import { MONTHLY_REPORT_ENDPOINT } from 'constants/urls'
import { MonthlyReportType } from 'types/revenue'

type MonthlyReportResult = {
  report: MonthlyReportType | undefined
  hasError: boolean
}

const useQueryMonthlyReport = (
  store_id: string,
  year: number | undefined,
  month: number | undefined
): MonthlyReportResult => {
  const dispatch = useDispatch()
  const [report, setReport] = useState<MonthlyReportType | undefined>(undefined)
  const [hasError, setHasError] = useState<boolean>(false)
  useEffect(() => {
    ;(async () => {
      if (!store_id || typeof year === 'undefined' || typeof month === 'undefined') return
      // 対象月の切り替え時に前回の結果を持ち越さない
      setReport(undefined)
      setHasError(false)
      dispatch(showLoading())
      // トークンを取得する
      const token = await auth.currentUser?.getIdToken()
      if (typeof !token === 'undefined') {
        dispatch(hideLoading())
        setHasError(true)
        console.error('認証トークンの取得に失敗しました。')
        return
      }
      // ヘッダーの宣言
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }
      try {
        const res: AxiosResponse<MonthlyReportType> = await axios.get(MONTHLY_REPORT_ENDPOINT, {
          headers,
          params: {
            store_id,
            year,
            month,
          },
        })
        dispatch(hideLoading())
        setReport({ ...res.data })
      } catch (e) {
        dispatch(hideLoading())
        // 取得に失敗した状態で0円を表示すると売上が無かったように見えてしまうため、
        // 呼び出し元でエラーを表示できるようにする
        setHasError(true)
        if (axios.isAxiosError(e)) {
          console.error(e.response)
        } else {
          console.error(e)
        }
        return
      }
    })()
  }, [store_id, year, month])
  return { report, hasError }
}

export default useQueryMonthlyReport
